export const DetailCard = (props) => {
  const { data, label, showSub = false, style = {} } = props || {};

  return (
    <div
      className={`p-4 lg:p-6 w-full rounded-md bg-white shadow-100`}
      style={style}
    >
      <span className="text-xl font-semibold text-gray-900 mt-4">{label}</span>
      {showSub && (
        <p className="font-semibold text-gray-700 mt-2">
          Please contact the Trial Administrator with any questions about this
          trial.
        </p>
      )}
      <hr className="mt-4" />
      <div className="mb-4" />
      {data.map((detail, index) => (
        <div key={detail.value} className="flex flex-row mt-4">
          {detail.icon}
          <span className="ml-2 text-base font-medium text-gray-700">
            {showSub && index === 3 ? "(000) 000-0000" : detail.value}
          </span>
        </div>
      ))}
    </div>
  );
};
